
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { ListItemIcon, ListItemText } from '@mui/material'
import React from 'react'
import Stack from '@mui/material/Stack';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import WorkIcon from '@mui/icons-material/Work';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import PaidIcon from '@mui/icons-material/Paid';
import FaceRetouchingOffIcon from '@mui/icons-material/FaceRetouchingOff';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import StrollerIcon from '@mui/icons-material/Stroller';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
const SwitchSubtipoInIcono = (props) => {

    switch (props.subtipo) {
        case 'Accidente de trabajo':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#fb0000' }}> <LocalPharmacyIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#fb0000' }}> {props.subtipo}</ListItemText>
                    </Stack>
                </>
            )
        case 'Enf. Gral./Acc. Fuera trab.':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#017630' }}> <MedicalServicesIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#017630' }}> {props.subtipo}</ListItemText>
                    </Stack>
                </>
            )
        case 'Licencia 140 Bis':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#109DFA' }}> <FamilyRestroomIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#109DFA' }}> {props.subtipo}</ListItemText>
                    </Stack>
                </>
            )
        case 'Incapacidad por maternidad':
            return (
                <>
                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#FF689D' }}> <StrollerIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#FF689D' }}> {props.subtipo}</ListItemText>
                    </Stack>
                </>
            )
        case 'Retardos':
            return (
                <>
                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#FF8A00' }}> <DirectionsRunIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#FF8A00' }}> {props.subtipo}</ListItemText>
                    </Stack>


                </>
            )
        case 'Faltas injustificadas':
            return (
                <>
                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#FF8A00' }}> <FaceRetouchingOffIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#FF8A00' }}> {props.subtipo}</ListItemText>
                    </Stack>
                </>
            )
        case 'Incremento salario':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#0017BE' }}> <AttachMoneyIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#0017BE' }}> {props.subtipo}</ListItemText>
                    </Stack>
                </>
            )
        case 'Gratificación':
            return (
                <>
                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#017630' }}> <AttachMoneyIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#017630' }}> {props.subtipo}</ListItemText>
                    </Stack>
                </>
            )
        case 'Compensación':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#017630' }}> <PaidIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#017630' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Día festivo / descanso':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#0046FF' }}> <CalendarMonthIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#0046FF' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Permisos sin goce de sueldo':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#FF8A00' }}> <WorkIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#FF8A00' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Permisos con goce de sueldo':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#05A360' }}> <WorkIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#05A360' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Baja':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#FF0000' }}> <ArrowDownwardIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#FF0000' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Reingreso':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#FF8A00' }}> <SyncAltIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#FF8A00' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )

        case 'Horas extras 5':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#8300FF' }}> <WorkHistoryIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#8300FF' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Horas extras 4':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#8300FF' }}> <WorkHistoryIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#8300FF' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Horas extras 3':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#8300FF' }}> <WorkHistoryIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#8300FF' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Horas extras 2':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#8300FF' }}> <WorkHistoryIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#8300FF' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )
        case 'Horas extras 1':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#8300FF' }}> <WorkHistoryIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#8300FF' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )

        case 'Préstamo empresa':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#FF0000' }}> <CurrencyExchangeIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#FF0000' }}> {props.subtipo}</ListItemText>
                    </Stack>

                </>
            )


        default:
            return (
                <>
                </>
            )

    }
}

export default SwitchSubtipoInIcono
